/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Create_OneInputs */

const en_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create one`)
};

const fr_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En creer un`)
};

const de_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle einen`)
};

const it_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creane uno`)
};

const ru_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте один`)
};

const es_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea uno`)
};

const zh_cn2_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建一个`)
};

const ja_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成する`)
};

const hi_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक तैयार करें`)
};

const pt_pt2_knp_lookup_create_one = /** @type {(inputs: Knp_Lookup_Create_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um`)
};

/**
* | output |
* | --- |
* | "Create one" |
*
* @param {Knp_Lookup_Create_OneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_create_one = /** @type {((inputs?: Knp_Lookup_Create_OneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Create_OneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_create_one(inputs)
	if (locale === "de") return de_knp_lookup_create_one(inputs)
	if (locale === "it") return it_knp_lookup_create_one(inputs)
	if (locale === "ru") return ru_knp_lookup_create_one(inputs)
	if (locale === "es") return es_knp_lookup_create_one(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_create_one(inputs)
	if (locale === "ja") return ja_knp_lookup_create_one(inputs)
	if (locale === "hi") return hi_knp_lookup_create_one(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_create_one(inputs)
	return en_knp_lookup_create_one(inputs)
});